import Vue from 'vue'

export default {
    resetStateMutation(state) {
        Vue.set(state, "gridIsOpen", true);
        Vue.set(state, "formIsOpen", false);
    },
    setFormOpen(state) {
        state.gridIsOpen = false;
        state.formIsOpen = true;
    },
    setFormClose(state) {
        state.gridIsOpen = true;
        state.formIsOpen = false;
    }
}
